import type { FC } from 'react'

import NextButton from '../../Icons/ButtonPagination/NextButton'
import PrevButton from '../../Icons/ButtonPagination/PrevButton'
import Dotts from '../dotts/Dotts'
import PaginationItem from '../PagintationItem/PaginationItem'
export interface IPagList {
  countPage: number
  currentPage: number
  setCurrentPage: (number: number) => void
}
interface ISetArr {
  isDottsLeft: boolean
  isDottsRight: boolean
  listPage: number[]
}

const createMas = (total: number, currentPage: number) => {
  const firstPage = 1
  const returnMas: ISetArr = {
    isDottsLeft: false,
    isDottsRight: false,
    listPage: []
  }
  if (total <= 6) {
    let i = 2
    while (i < total) {
      returnMas.listPage.push(i)
      i++
    }
    return returnMas
  }
  if (currentPage + 3 >= total || currentPage - 3 <= firstPage) {
    if (currentPage + 3 >= total) {
      returnMas.isDottsLeft = true
      let countPage = total - 1
      while (countPage > currentPage) {
        returnMas.listPage.push(countPage)
        countPage--
      }
      returnMas.listPage =
        currentPage === total
          ? [...returnMas.listPage, currentPage - 1, currentPage - 2].reverse()
          : [...returnMas.listPage, currentPage, currentPage - 1, currentPage - 2].reverse()
      return returnMas
    }
    if (currentPage - 3 <= firstPage) {
      returnMas.isDottsRight = true
      let countPage = 2
      while (countPage < currentPage) {
        returnMas.listPage.push(countPage)
        countPage++
      }
      returnMas.listPage =
        currentPage === 1
          ? [
              ...returnMas.listPage,
              currentPage + 1,
              currentPage + 2,
              currentPage + 3,
              currentPage + 4
            ]
          : [...returnMas.listPage, currentPage, currentPage + 1, currentPage + 2]
      return returnMas
    }
  } else {
    returnMas.isDottsLeft = true
    returnMas.isDottsRight = true
    returnMas.listPage = [
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2
    ]
  }
  return returnMas
}

const PaginationList: FC<IPagList> = ({ countPage, currentPage, setCurrentPage }) => {
  const createList = (total: number, current: number) => {
    const { isDottsLeft, isDottsRight, listPage } = createMas(countPage, current)
    return (
      <>
        <PaginationItem setCurrentPage={setCurrentPage} isActive={currentPage === 1} value={1} />
        <Dotts isDotted={isDottsLeft} />
        {listPage.map(item => {
          return (
            <PaginationItem
              setCurrentPage={setCurrentPage}
              key={item}
              isActive={currentPage === item}
              value={item}
            />
          )
        })}
        <Dotts isDotted={isDottsRight} />
        <PaginationItem
          setCurrentPage={setCurrentPage}
          isActive={currentPage === total}
          value={total}
        />
      </>
    )
  }
  const onPrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }
  const onNextClick = () => {
    if (currentPage < countPage) {
      setCurrentPage(currentPage + 1)
    }
  }
  return (
    <ul className='pagination__list'>
      <li className='prev'>
        <PrevButton onClick={onPrevClick} />
      </li>
      {createList(countPage, currentPage)}
      <li className='next'>
        <NextButton onClick={onNextClick} />
      </li>
    </ul>
  )
}

export default PaginationList
